<div class="form-group">
    <label>
        {{ label }}
        @if (required) {
<span class="text-danger">*</span>
}
        @if (type === 'number' && (min !== undefined || max !== undefined) && label !='') {
<span class="info-icon">
            <i class="fa fa-info-circle"></i>
            <div class="tooltip-number">
                @if (min !== undefined) {
<div>Min: {{ min }}</div>
}
                @if (max !== undefined) {
<div>Max: {{ max }}</div>
}
            </div>
        </span>
}
    </label>

    <input [type]="type === 'number' && decimalSupport ? 'text' : (type === 'password' ? 'password' : type)"
        class="form-control" [class.is-invalid]="control.invalid && (control.dirty || control.touched)"
        [formControl]="$any(control)" [placeholder]="placeholder" [min]="type === 'number' && !decimalSupport ? min : null"
        [max]="type === 'number' && !decimalSupport ? max : null"
        [step]="type === 'number' && !decimalSupport ? step : null" [minlength]="type === 'text' ? minLength : null"
        [maxlength]="type === 'text' ? maxLength : null" (keypress)="type === 'number' ? onKeyPress($event) : null"
        (input)="type === 'number' ? onNumberInput($event) : onInputChange($event)"
        (blur)="type === 'number' ? onNumberBlur($event) : null" [attr.data-id]="dataId" />

    @if (control.invalid && (control.dirty || control.touched)) {
<div class="text-danger"
        [ngClass]="{ 'error-message': label, 'error-message-pid': !label }">
        {{ getErrorMessage() }}
    </div>
}
</div>